export var SignUpSource;
(function (SignUpSource) {
    SignUpSource["CloneFromExistingInvestor"] = "cloneFromExistingInvestor";
    SignUpSource["Upload"] = "upload";
    SignUpSource["AddSingleInvestor"] = "addSingleInvestor";
    SignUpSource["Adviser"] = "adviser";
    SignUpSource["SelfSignup"] = "selfSignup";
})(SignUpSource || (SignUpSource = {}));
//# sourceMappingURL=schema.js.map